export default __webpack_public_path__ + "static/grandesemepresas-fbeeb6fb5e871d8c72025c13609b5049.png";